/**
 * Feature flags for Skogskalkyl Wartemodus (maintenance mode).
 *
 * Controlled via frontend environment variables. Defaults are "disabled"
 * so the public UI stays in maintenance mode unless explicitly enabled.
 *
 * Backend, Stripe, Resend and the database are NOT affected by these flags.
 * They only gate what is reachable through the public UI.
 */

export const SALES_ENABLED =
  process.env.REACT_APP_SALES_ENABLED === 'true';

export const AUTH_ENABLED =
  process.env.REACT_APP_AUTH_ENABLED === 'true';

export const MAINTENANCE_MSG =
  'Beslutsbrev testas för närvarande. Kontakta info@hodema.se om du vill veta mer.';

export const MAINTENANCE_SUPPORT_EMAIL = 'info@hodema.se';

/**
 * Error thrown when the sales / checkout pathway is invoked while
 * SALES_ENABLED is false. Use to short-circuit before any network call
 * to /api/payments/create-checkout or /api/beslutslage/checkout.
 */
export class SalesDisabledError extends Error {
  constructor(message = MAINTENANCE_MSG) {
    super(message);
    this.name = 'SalesDisabledError';
    this.isSalesDisabled = true;
  }
}
